<script>
import { VMoney } from 'v-money'
import { aporte } from '@constants/URL'
import Title from '@components/section-title'
import store from '@state/store'
import { TIPO_SALDO_EM_CONTA } from '@modules/consolidator/constants/AssetDetailsFicha'
import {
  validarData,
  getCorretoraSimple,
  possivelJSON,
  getDataCotizacao,
  getNumber,
  formatNumber,
  formatNumberZero,
  compararDatas,
  toMoney,
} from '@utils/Format'
import { MODAL, RELOAD, TIPOS_RV } from '@constants/Text'
import { filter } from '@utils/Search'
import con from '@services/connection'
import Vue from 'vue'
import { aawzDate } from '@utils/dates/aawz-date'
import { GlobalBus } from '@services/bus'
import { ASSETS_TYPES } from '@modules/consolidator/constants/Assets'
import { apiConsolidatorSuggestions } from '@modules/consolidator/api/apiConsolidatorSuggestions'
import { patchSalvoDaMovimentacao } from '@modules/consolidator/utils/suggestion-to-movimentacao/suggestion-to-movimentacao'
import { SUGESTOES_IA_VIEW } from '@modules/consolidator/constants/Text'
import { apiConsolidatorCotizacao } from '@modules/consolidator/api/apiConsolidatorCotizacao'
import { isUsdCurrency as isUsdCurrencyText } from '@modules/consolidator/utils/Currency/Currency.js'
import { buildQuantityDecimalProps } from '@modules/consolidator/utils/asset-form-schema/asset-form-schema'
import { getMovementFieldConfig } from '@modules/consolidator/constants/register-asset/movement-field-config'
import AiGeneratedNote from '@modules/back-office/components/ai-generated-note/ai-generated-note.vue'
import { COPY_BY_MODO } from '@modules/consolidator/constants/register-asset/movement-copy-by-mode'

export default {
  components: { Title, AiGeneratedNote },
  directives: {
    money: VMoney,
  },
  props: {
    bus: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      TIPOS_RV,
      busModal: new Vue(),
      notaIa: null,
      // Sugestao que originou esta edicao. Sem ela o modal salvava a movimentacao e a sugestao
      // ficava Pendente para sempre — o caminho do CADASTRO ja resolvia, o de MOVIMENTACAO nao.
      sugestaoEmEdicao: null,
      showStepper: true,
      loading: false,
      loadingSave: false,
      rules: {
        data: (v) => !!validarData(v) || 'Formato inválido',
        positive: (v) => getNumber(v) >= 1 || 'Maior que 0',
        required: (v) => !!v || 'Campo obrigatório',
        minDate: (v) =>
          this.dataAplicacaoInicial
            ? compararDatas(v, this.dataAplicacaoInicial) === 1 ||
              `A data deve ser maior ou igual que ${this.dataAplicacaoInicial}`
            : true,
        minDateCotizacao: (v) =>
          compararDatas(v, this.edit.dataAplicacao) !== -1 ||
          `A data deve ser maior ou igual que ${this.edit.dataAplicacao}`,
        maxDate: (v) =>
          compararDatas(v, aawzDate().format('DD/MM/YYYY')) !== 1 ||
          `A data deve ser menor ou igual que ${aawzDate().format(
            'DD/MM/YYYY'
          )}`,
        minValor: (v) =>
          getNumber(v) > 0 || this.tab !== 'por-valor' || 'Valor inválido',
        minQtd: (v) =>
          getNumber(v) > 0 || this.tab !== 'por-quantidade' || 'Valor inválido',
      },
      maskNumber: '#######################',
      edit: {
        dataCotizacao: '',
        dataAplicacao: '',
        nome_ativo: '',
        ativo: {},
        id_aplicacao: null,
        valor: 0,
        pu: 0,
        qtd: 1,
        resgate_total: false,
        preco_compra: 0,
        saldo_conta: false,
        marcacao_curva: false,
      },
      tab: null,
      modo: 'Aplicar',
      search: '',
      ativos: [],
      step: 1,
      cliente: {},
      disabled: {},
      editar: false,
      dataAplicacaoInicial: '',
      id_ativo_cliente_temp: '',
      getNumber: getNumber,
      saldo_em_conta: 0,
      saldos_em_conta: [],
      ativo_saldo_em_conta: '',
      open_select: false,
      asset_selected: false,
      open_new_mov: true,
      ASSETS_TYPES,
    }
  },
  computed: {
    id_cliente() {
      return this.cliente.id
    },
    usuarioAtual() {
      return store.getters['user/currentUser'] || {}
    },
    tabelaAtivos() {
      const ativos = filter(this.ativos, 'nome_ativo', this.search)
      return ativos
    },
    larguraModal() {
      return this.mostrarStepper && this.passoAtual === 1 ? '800px' : '1200px'
    },
    tituloModal() {
      return this.editar ? 'Editar movimentação' : 'Aporte/Resgate'
    },
    mostrarCamposObrigatorios() {
      return !this.mostrarStepper || this.passoAtual === 2
    },
    mostrarStepper() {
      return !this.editar && this.showStepper && !this.asset_selected
    },
    opcoesModo() {
      if (this.edit.nome_ativo === TIPO_SALDO_EM_CONTA) {
        return [
          { value: 'Aplicar', text: 'Depósito' },
          { value: 'Resgatar', text: 'Saque' },
        ]
      }
      return [
        { value: 'Aplicar', text: 'Aplicar' },
        { value: 'Resgatar', text: 'Resgatar' },
      ]
    },
    opcoesAplicacaoPor() {
      const opcoes = []
      if (this.showTabValor) {
        opcoes.push({ value: 'por-valor', text: 'Valor total' })
      }
      if (this.showTabQuantidade) {
        opcoes.push({ value: 'por-quantidade', text: 'Quantidade' })
      }
      return opcoes
    },
    mostrarAplicacaoPor() {
      return (
        !this.edit.resgate_total ||
        this.isAcao ||
        this.hasPrecoCompra ||
        this.isRF ||
        this.isOffshore
      )
    },
    colsAplicacaoPor() {
      return this.tab === 'por-quantidade' && this.showPrecoCompra ? 3 : 4
    },
    colsCampoDependente() {
      if (this.tab === 'por-valor') {
        return 8
      }
      return this.showPrecoCompra ? 3 : 4
    },
    rotuloAplicacaoPor() {
      return this.copyDoModo.criterio
    },
    cabecalhosAtivos() {
      return [
        { text: 'Ativo', value: 'nome_ativo', sortable: false },
        { text: 'Corretora', value: 'corretora', sortable: false },
        { text: 'Investido', value: 'pl_atual', align: 'end', sortable: false },
        { text: '', value: 'acao', align: 'end', sortable: false, width: 48 },
      ]
    },
    rotuloDataAplicacao() {
      return this.copyDoModo.data
    },
    rotuloValor() {
      return this.copyDoModo.valor
    },
    rotuloPrecoUnitario() {
      if (this.showPrecoCompra) {
        const operacao = this.copyDoModo.operacao
        return `Preço unitário de ${operacao}*`
      }
      return 'Preço unitário*'
    },
    mostrarVoltar() {
      return this.mostrarStepper && this.passoAtual > 1
    },
    copyDoModo() {
      return COPY_BY_MODO[this.modo] || COPY_BY_MODO.Aplicar
    },
    textoListaVazia() {
      return this.search
        ? 'Nenhum ativo encontrado para essa busca'
        : 'Esse cliente ainda não tem ativos cadastrados'
    },
    saldoFormatado() {
      return toMoney(this.valorSaldoEmConta)
    },
    mostrarCancelar() {
      return !this.mostrarVoltar
    },
    passoAtual: {
      get() {
        return Number(this.step)
      },
      set(passoRecebido) {
        const passo = Number(passoRecebido)
        if (passo === 1 && this.step !== 1) {
          this.search = ''
          this.disabled = {}
          this.dataAplicacaoInicial = ''
        }
        this.step = passo
      },
    },
    isAcao() {
      return [
        'Ação',
        'Ações',
        'FII',
        'Fundos Imobiliários',
        'Fundo Imobiliário',
        ASSETS_TYPES.CRIPTO,
      ].includes(this.edit.ativo.tipo)
    },
    isRV() {
      return TIPOS_RV.includes(this.edit.ativo.tipo)
    },
    isOffshore() {
      return [
        ASSETS_TYPES.ACOES_OFFSHORE.toLowerCase(),
        ASSETS_TYPES.FUNDOS_OFFSHORE.toLowerCase(),
      ].includes((this.edit.ativo.tipo || '').toLowerCase())
    },
    movementFieldConfig() {
      return getMovementFieldConfig({ tipo: (this.edit.ativo || {}).tipo })
    },
    decimalLength() {
      return this.movementFieldConfig.pu.decimals
    },
    quantityUsesCommaInput() {
      return this.movementFieldConfig.quantidade.inputType !== 'number'
    },
    quantityDecimalLength() {
      return { min: 0, max: this.movementFieldConfig.quantidade.decimals }
    },
    puCurrencyProps() {
      if (this.movementFieldConfig.pu.freeDecimal) {
        return buildQuantityDecimalProps(this.movementFieldConfig.pu.decimals)
      }
      return { decimalLength: this.movementFieldConfig.pu.decimals }
    },
    quantityInputType() {
      return this.movementFieldConfig.quantidade.inputType
    },
    quantityCurrencyProps() {
      if (this.movementFieldConfig.quantidade.inputType === 'decimal') {
        return buildQuantityDecimalProps(
          this.movementFieldConfig.quantidade.decimals
        )
      }
      return {}
    },
    moneyInputType() {
      return this.shouldUseDollarMask ? 'money_dolar' : 'money'
    },
    shouldUseDollarMask() {
      if (this.assetCurrency) {
        return this.isUsdCurrency
      }
      return this.isOffshore
    },
    assetCurrency() {
      return (this.edit.ativo || {}).moeda || ''
    },
    isUsdCurrency() {
      return isUsdCurrencyText({ currency: this.assetCurrency })
    },
    isRF() {
      return ['renda fixa', 'tesouro direto'].includes(
        (this.edit.ativo.tipo || '').toLowerCase()
      )
    },
    hasPrecoCompra() {
      return ['Renda Fixa', 'Operações Estruturadas'].includes(
        this.edit.ativo.tipo
      )
    },
    showPrecoCompra() {
      return (
        this.hasPrecoCompra &&
        !this.disabled.preco_compra &&
        this.edit.operacao !== 'Inicial'
      )
    },
    hasSaldoEmConta() {
      return Object.values(this.saldos_em_conta)
        .map((v) => {
          return v && v.data && v.data.corretora
        })
        .includes(this.edit.ativo.corretora)
    },
    valorSaldoEmConta() {
      let saldo_em_conta = Object.values(this.saldos_em_conta).find((v) => {
        return v && v.data && v.data.corretora === this.edit.ativo.corretora
      })
      if (saldo_em_conta) {
        return saldo_em_conta.data.pl_atual || 0
      } else {
        return 0
      }
    },
    showTabValor() {
      return (
        (!this.edit.resgate_total &&
          !(this.modo !== 'Aplicar' && this.hasPrecoCompra)) ||
        this.isRF
      )
    },
    showTabQuantidade() {
      return this.edit.ativo.nome_ativo !== TIPO_SALDO_EM_CONTA
    },
  },
  created() {
    if (this.bus) {
      this.bus.$on(MODAL.CADASTRAR_APORTE, this.abrirModal)
    }
    this.busModal.$on('close', () => {
      this.clear()
    })
  },
  beforeDestroy() {
    if (this.bus) {
      this.bus.$off(MODAL.CADASTRAR_APORTE, this.abrirModal)
    }
  },
  methods: {
    // 5o argumento OPCIONAL: quando a abertura vem de uma sugestao de IA, o chamador manda o
    // texto para o modal exibir a MESMA nota do formulario de ativo. Fica NESTE wrapper, e nao
    // dentro de `open`, de proposito: `open` ja carrega complexidade legada (S3776/S1541) e tocar
    // nela faria o Sonar atribuir a divida inteira a este PR. As outras 4 telas que abrem o modal
    // seguem identicas — `notaIa` chega `null` e nada muda.
    abrirModal(
      v,
      a,
      asset,
      open_new_mov = true,
      notaIa = null,
      sugestao = null
    ) {
      this.open(v, a, asset, open_new_mov)
      this.notaIa = notaIa
      this.sugestaoEmEdicao = sugestao
    },
    // Espelha `resolverSugestaoAceita` do formulario de ativo: salvar pelo caminho "Editar e
    // aceitar" tem que TIRAR a sugestao da fila. O patch sai do que foi realmente gravado, porque o
    // assessor pode ter mudado o valor proposto antes de salvar.
    // Devolve SE a sugestao saiu da fila. Quem avisa e o `salvar`, com UMA mensagem: o snack e
    // substituicao, nao fila (`SHOW_SNACKBAR` sobrescreve o estado), entao um aviso emitido aqui
    // seria apagado pelo "editada com sucesso" tres linhas depois — e a falha ficaria invisivel.
    async resolverSugestaoAceita(dataSalva) {
      const sugestao = this.sugestaoEmEdicao
      if (!sugestao) return true
      const dados = patchSalvoDaMovimentacao(dataSalva)
      const r = await apiConsolidatorSuggestions.aceitar({
        id: sugestao.id,
        dados,
      })
      if (r && r.status === 200) {
        // So limpa no SUCESSO: limpar antes do await deixava um aceite que falhou sem retentativa,
        // porque o proximo `Salvar` do mesmo modal ja nao via a sugestao.
        this.sugestaoEmEdicao = null
        GlobalBus.$emit(RELOAD.IA_CURADORIA)
        return true
      }
      return false
    },
    edicaoDeMovimentacao(a, asset) {
      return {
        dataCotizacao: a.data_cotizacao,
        dataAplicacao: a.data,
        nome_ativo: a.nome_ativo,
        id_aplicacao: a.id_aplicacao,
        ativo: {
          ...a,
          tipo: a.tipo || a['Tipo'] || (asset || {}).tipo || (asset || {}).Tipo,
          id_conta: a.id_conta,
          nome_ativo: a.nome_ativo,
          id: a.id_ativo_cliente,
          referencia: (asset || a || {}).referencia,
        },
        valor: a.valor !== '-' ? formatNumber(getNumber(a.valor)) : 0,
        pu: 0,
        operacao: a.operacao,
        qtd: a.quantidade || null,
        resgate_total: a.resgate_total,
        preco_compra: 0,
        impostos: a.impostos || 0,
        taxas: a.taxas || 0,
        cotacao: a.cotacao || 0,
      }
    },
    ajustarPrecisaoDaEdicao(a, asset) {
      this.edit.pu =
        a.valor_unitario !== '-'
          ? formatNumber(getNumber(a.valor_unitario), this.decimalLength)
          : 0
      this.edit.preco_compra = formatNumber(
        getNumber(a.preco_compra || (asset || {}).pu || 0),
        this.decimalLength
      )

      if (this.quantityUsesCommaInput && this.edit.qtd) {
        this.edit.qtd = formatNumberZero(
          getNumber(this.edit.qtd),
          this.quantityDecimalLength.max
        )
      }

      if (getNumber(this.edit.preco_compra)) {
        this.$set(this.disabled, 'preco_compra', true)
      }
    },
    definirAbaDaEdicao() {
      this.tab =
        this.isAcao ||
        this.isOffshore ||
        this.hasPrecoCompra ||
        (this.edit.ativo.tipo === 'Tesouro Direto' && this.edit.pu)
          ? 'por-quantidade'
          : 'por-valor'

      if (this.edit.valor && !(this.edit.qtd && this.edit.pu)) {
        this.tab = 'por-valor'
      }

      if (this.edit.qtd && this.edit.pu) {
        this.tab = 'por-quantidade'
      }
    },
    abrirParaEdicao(a, asset) {
      this.passoAtual = 2
      this.editar = true
      this.edit = this.edicaoDeMovimentacao(a, asset)

      this.ajustarPrecisaoDaEdicao(a, asset)

      this.modo =
        a.operacao === 'Resgate' || a.resgate_total ? 'Resgatar' : 'Aplicar'

      this.$nextTick(() => {
        this.definirAbaDaEdicao()
      })
    },
    abrirParaAtivoEscolhido(asset) {
      this.modo = 'Aplicar'
      this.showStepper = false

      this.selectAsset(asset, true)
    },
    open(v, a, asset, open_new_mov = true) {
      this.clear()

      if (typeof v === 'object') {
        this.cliente = v
      }

      this.open_new_mov = open_new_mov

      if (a) {
        this.abrirParaEdicao(a, asset)
      } else if (asset) {
        this.abrirParaAtivoEscolhido(asset)
      }

      this.loadAssets()
      if (this.$refs.form) {
        this.$refs.form.resetValidation()
      }

      if (Object.keys(a || {}).includes('marcacao_curva') && this.isRF) {
        this.edit.marcacao_curva = a.marcacao_curva
        this.changeMarcacao()
      }

      this.busModal.$emit('dialog', !!v)
    },
    definirBuscaAtivo(termo) {
      this.search = termo || ''
    },
    escolherAtivo(ativo) {
      this.selectAsset(ativo)
    },
    selecionarModo(valorSelecionado) {
      this.edit.resgate_total = false
      this.modo = valorSelecionado
    },
    openNewAsset() {
      GlobalBus.$emit(MODAL.CONSOLIDADOR_REGISTER_ASSET, {})
    },
    async loadAssets() {
      if (this.loading) {
        return
      }
      if (this.id_cliente) {
        this.loading = true
        const data = {
          id_cliente_app: this.id_cliente,
        }
        let r
        if (this.usuarioAtual.IS_CLIENTE) {
          r = await con.get(aporte.client.list_grouped, data)
        } else {
          r = await con.post(aporte.professional.list_grouped, data)
        }
        if (r && r.value) {
          this.ativos = Object.values(r.value)
            .filter((a) => a && a.data)
            .map((a) => {
              a = a.data
              a.corretora = getCorretoraSimple(a.corretora)
              return a
            })
            .filter((r) => {
              return (
                (r.nome_ativo || '').toLowerCase() !==
                TIPO_SALDO_EM_CONTA.toLowerCase()
              )
            })
          this.saldos_em_conta = Object.values(possivelJSON(r.value)).filter(
            (v) => {
              return v && v.data && v.data.nome_ativo === TIPO_SALDO_EM_CONTA
            }
          )
        }
        this.loading = false
      }
    },
    selectAsset(asset, asset_selected) {
      this.edit.preco_compra = formatNumber(
        getNumber(asset.preco_compra || asset.pu || 0),
        this.decimalLength
      )
      if (getNumber(this.edit.preco_compra)) {
        this.$set(this.disabled, 'preco_compra', true)
      }
      this.edit.nome_ativo = asset.nome_ativo
      asset.tipo = asset.tipo || asset.Tipo
      this.edit.ativo = asset
      this.asset_selected = asset_selected
      // this.edit.qtd = asset.quantidade
      this.dataAplicacaoInicial = aawzDate(
        asset.data_aplicacao_inicial
      ).isValid()
        ? aawzDate(asset.data_aplicacao_inicial).format('DD/MM/YYYY')
        : asset.data_aplicacao_inicial_f
        ? asset.data_aplicacao_inicial_f
        : ''

      if (asset_selected) {
        this.modo = asset.operacao === 'Resgatar' ? 'Resgatar' : 'Aplicar'
      }

      this.selecionarSaldoEmConta(asset.corretora)

      this.tab =
        this.isOffshore ||
        this.isAcao ||
        this.hasPrecoCompra ||
        (asset.tipo === 'Tesouro Direto' && (asset.pu || asset.valor_unitario))
          ? 'por-quantidade'
          : 'por-valor'

      // if (asset.valor && !(asset.qtd && (asset.pu || asset.valor_unitario))) {
      //   this.tab = 'por-valor'
      // }

      // if (asset.qtd && asset.pu) {
      //   this.tab = 'por-quantidade'
      // }

      this.passoAtual = 2
    },
    selecionarSaldoEmConta(corretora) {
      this.ativo_saldo_em_conta = this.saldos_em_conta.find((a) => {
        return (a.corretora || (a.data && a.data.corretora)) === corretora
      })
    },
    formatData() {
      const data = {
        id_cliente_app: this.id_cliente,
        id_conta: this.edit.ativo.id_conta,
        nome_ativo: this.edit.ativo.nome_ativo,
        valor:
          this.tab === 'por-quantidade' ? null : getNumber(this.edit.valor),
        quantidade:
          this.tab === 'por-quantidade' ? getNumber(this.edit.qtd) : null,
        valor_unitario:
          this.tab === 'por-quantidade'
            ? getNumber(this.edit.pu, this.decimalLength)
            : null,
        data_aplicacao: this.edit.dataAplicacao,
        data_cotizacao: this.edit.dataCotizacao,
        resgate_total: this.edit.resgate_total ? 1 : 0,
        alterar_saldo_em_conta: this.edit.saldo_conta || null,
        corretora_saldo_em_conta: this.edit.ativo.corretora || null,
        id_aplicacao: this.edit.id_aplicacao,
        pu_entrada:
          this.edit.preco_compra &&
          this.hasPrecoCompra &&
          !this.disabled.preco_compra
            ? getNumber(this.edit.preco_compra, this.decimalLength)
            : null,
        resgate: this.modo !== 'Aplicar',
        marcacao_curva: this.edit.marcacao_curva || false,
        impostos: this.edit.impostos === undefined ? null : this.edit.impostos,
        taxas: this.edit.taxas === undefined ? null : this.edit.taxas,
        cotacao: this.edit.cotacao === undefined ? null : this.edit.cotacao,
      }

      if (this.edit.resgate_total && !this.isAcao) {
        data['quantidade'] = null
        data['valor'] = null

        if (!['Renda Fixa', 'Tesouro Direto'].includes(this.edit.ativo.tipo)) {
          data['valor_unitario'] = null
        }
      }

      return data
    },
    urlDoSalvarCliente() {
      if (this.editar) {
        return this.edit.operacao === 'Inicial'
          ? aporte.client.edit_inicial
          : aporte.client.edit
      }
      return aporte.client.add
    },
    async enviarMovimentacao(data) {
      if (this.usuarioAtual.IS_CLIENTE) {
        return con.post(this.urlDoSalvarCliente(), data)
      }
      if (this.editar) {
        data['editar_inicial'] = this.edit.operacao === 'Inicial'
        const url =
          this.edit.operacao === 'Inicial'
            ? aporte.professional.manage_add
            : aporte.professional.manage + this.edit.id_aplicacao
        return con.put(url, data)
      }
      return con.post(aporte.professional.manage_add, data)
    },
    snackDoSalvar(r, sugestaoResolvida) {
      if (sugestaoResolvida) {
        return { text: r.message, button: true }
      }
      return {
        text: SUGESTOES_IA_VIEW.movimentacaoSalvaSugestaoPendente,
        color: 'warning',
        button: true,
      }
    },
    async salvar(close) {
      if (this.loadingSave) {
        return
      }

      if (this.$refs.form.validate()) {
        this.loadingSave = true

        const data = this.formatData()
        data['id'] = this.edit.ativo.id

        const r = await this.enviarMovimentacao(data)

        let sugestaoResolvida = true
        if (r && r.status === 200) {
          sugestaoResolvida = await this.resolverSugestaoAceita(data)
          apiConsolidatorCotizacao
            .run({ id_cliente: this.id_cliente })
            .then(() => {
              console.log('Recalculando cotizacao')
            })
        }

        this.$showSnack(this.snackDoSalvar(r, sugestaoResolvida))
        this.loadingSave = false
        this.modalNewMovement(close)
      }
    },
    clear() {
      this.notaIa = null
      this.sugestaoEmEdicao = null
      this.edit = {
        dataCotizacao: '',
        dataAplicacao: '',
        nome_ativo: '',
        ativo: {},
        valor: 0,
        pu: 0,
        qtd: null,
        id_aplicacao: null,
        resgate_total: false,
        saldo_conta: false,
        marcacao_curva: false,
      }
      this.saldo_em_conta = 0
      this.disabled = {}
      this.passoAtual = 1
      this.asset_selected = false
      this.showStepper = true
      this.tab = 'por-valor'
      this.modo = 'Aplicar'
      this.search = ''
      this.editar = false
      this.ativos = []
      this.cliente = {}
    },
    clearData() {
      this.loading = true
      this.edit.dataCotizacao = ''
      this.edit.dataAplicacao = ''
      this.edit.valor = 0
      this.edit.pu = 0
      this.edit.qtd = null
      this.edit.resgate_total = false
      this.tab =
        this.isOffshore || this.isAcao || this.hasPrecoCompra
          ? 'por-quantidade'
          : 'por-valor'
      this.modo = 'Aplicar'
      this.loading = false
    },
    async coletarDataCotizacao() {
      if ((this.edit.dataAplicacao || '').length === 10) {
        this.edit.dataCotizacao = await getDataCotizacao(
          this.edit.dataAplicacao,
          this.modo,
          this.edit.ativo.referencia,
          this.edit.ativo.tipo
        )
      }
    },
    validDate(d) {
      if (d.length === 10) {
        return !!validarData(d)
      }
      return true
    },
    changeResgateTotal(v) {
      if (v) {
        this.tab = 'por-quantidade'
      } else {
        if (this.isAcao || this.hasPrecoCompra || this.isOffshore) {
          this.tab = 'por-quantidade'
        } else {
          this.tab = 'por-valor'
        }
      }
    },
    verifySaldoConta() {
      if (
        Object.values(this.saldos_em_conta)
          .map((v) => {
            return v && v.data && v.data.corretora
          })
          .includes(this.edit.ativo.corretora)
      ) {
        this.open_select = true
      }
    },
    selectSaldoEmConta() {
      this.ativo_saldo_em_conta = Object.values(this.saldos_em_conta).find(
        (v) => {
          return (
            v &&
            v.data &&
            v.data.corretora === this.ativo_saldo_em_conta.split('- ')[1]
          )
        }
      )
    },
    modalNewMovement(close) {
      if (this.editar || !this.open_new_mov) {
        this.clear()
        this.bus.$emit('reload_movements', true)
        GlobalBus.$emit(RELOAD.MOVEMENTS_MODAL, true)
        GlobalBus.$emit(RELOAD.MOVEMENTS, true)
        close()
        return
      }
      this.$showModal({
        text: `Deseja criar outra movimentação para esse mesmo ativo e cliente?`,
        title: 'Nova movimentação',
        'max-width': '500px',
        closable: false,
        persistent: true,
        buttons: [
          {
            text: 'Não',
            class: { underlined: true },
            action: () => {
              this.clear()
              close()
              this.bus.$emit('reload_movements', true)
              GlobalBus.$emit(RELOAD.MOVEMENTS_MODAL, true)
              GlobalBus.$emit(RELOAD.MOVEMENTS, true)
            },
          },
          {
            text: 'Sim',
            class: { primary: true },
            action: () => {
              this.clearData()
            },
          },
        ],
      })
    },
    changeMarcacao() {
      if (this.edit.marcacao_curva) {
        this.tab = 'por-valor'
      } else {
        this.tab = 'por-quantidade'
      }
    },
  },
}
</script>

<template>
  <BaseModal
    content-class="no-overflow-x modal-aporte-resgate"
    :max-width="larguraModal"
    :bus="busModal"
    persistent
    fixed-actions
  >
    <template v-slot:title>
      <Title
        :title="tituloModal"
        :subtitle="cliente.name"
        underlined
        class="mb-4"
      />
    </template>
    <div class="v-aplication">
      <AiGeneratedNote v-if="notaIa" class="mb-6" :texto="notaIa" />

      <div class="v-application">
        <v-stepper v-model="passoAtual" class="elevation-0 w-100">
          <v-stepper-header v-if="mostrarStepper" class="elevation-0">
            <v-stepper-step :editable="passoAtual > 1" step="1">
              Escolha o ativo
            </v-stepper-step>
            <v-divider />
            <v-stepper-step :editable="passoAtual > 2" step="2">
              Adicione a movimentação
            </v-stepper-step>
          </v-stepper-header>
          <v-stepper-items class="elevation-0">
            <v-stepper-content step="1" class="pt-1 pb-0">
              <v-row v-if="loading" justify="center" align="center">
                <div class="text-center ma-12 w-100">
                  <v-progress-circular
                    :size="50"
                    color="primary"
                    indeterminate
                  ></v-progress-circular>
                </div>
              </v-row>
              <div v-else class="col-12 pb-0">
                <BaseTable
                  v-if="passoAtual === 1"
                  show-search
                  external-search
                  disable-margin-top
                  search-placeholder="Pesquisar ativo"
                  search-clearable
                  :search-value="search"
                  height="100%"
                  fixed-header
                  :headers="cabecalhosAtivos"
                  :items="tabelaAtivos"
                  :items-per-page="-1"
                  :no-data-text="''"
                  :class="{
                    'modal-aporte-resgate__tabela--vazia': !tabelaAtivos.length,
                  }"
                  hide-default-footer
                  @update:searchValue="definirBuscaAtivo"
                  @click:row="escolherAtivo"
                >
                  <template v-slot:[`item.pl_atual`]="{ item }">
                    <span class="text-no-wrap">{{ item.pl_atual }}</span>
                  </template>
                  <template v-slot:[`item.acao`]>
                    <icon-svg
                      name="mdi-chevron-right"
                      :size="18"
                      color="#8E8E8E"
                    />
                  </template>
                </BaseTable>
                <div
                  v-if="!tabelaAtivos.length"
                  class="modal-aporte-resgate__vazio d-flex flex-column align-center justify-center az-gap"
                >
                  <p class="text-sm text-color-900 mb-0">
                    {{ textoListaVazia }}
                  </p>
                  <BaseButton v-if="search" outline dark @click="search = ''">
                    Limpar busca
                  </BaseButton>
                  <BaseButton v-else primary @click="openNewAsset">
                    Cadastrar ativo
                  </BaseButton>
                </div>
              </div>
            </v-stepper-content>

            <v-stepper-content step="2" class="pt-0">
              <v-form ref="form">
                <div class="d-flex justify-center mb-5">
                  <BaseToggleButton
                    :value="modo"
                    :options="opcoesModo"
                    small
                    buttonStyle="flatGray"
                    role="group"
                    aria-label="Tipo de movimentação"
                    @input="selecionarModo"
                  />
                </div>

                <v-row>
                  <v-col cols="12" class="py-2">
                    <input-by-type
                      v-model="edit.nome_ativo"
                      labelExternal="Nome do ativo"
                      class="new-ux"
                      outlined
                      disabled
                    />
                  </v-col>
                  <v-col v-if="modo === 'Resgatar'" cols="12" class="py-2">
                    <v-checkbox
                      v-model="edit.resgate_total"
                      label="Resgate total"
                      class="mt-0"
                      hide-details
                      @change="changeResgateTotal"
                    />
                  </v-col>
                  <v-col cols="6" class="py-2">
                    <input-by-type
                      v-model="edit.dataAplicacao"
                      type="date"
                      :labelExternal="rotuloDataAplicacao"
                      placeholder="DD/MM/AAAA"
                      class="new-ux"
                      outlined
                      :rules="[rules.data, rules.required, rules.maxDate]"
                      @input="coletarDataCotizacao"
                    />
                  </v-col>
                  <v-col cols="6" class="py-2">
                    <input-by-type
                      v-model="edit.dataCotizacao"
                      type="date"
                      labelExternal="Data de cotização*"
                      placeholder="DD/MM/AAAA"
                      class="new-ux"
                      outlined
                      :rules="[rules.data, rules.minDateCotizacao]"
                    />
                  </v-col>
                  <v-col v-if="isRF" cols="12" class="py-2">
                    <v-checkbox
                      v-model="edit.marcacao_curva"
                      label="Marcar sempre na curva"
                      dense
                      hide-details
                      class="mt-0"
                    />
                  </v-col>
                  <template v-if="mostrarAplicacaoPor">
                    <v-col :cols="colsAplicacaoPor" class="py-2">
                      <input-by-type
                        v-model="tab"
                        type="select"
                        :options="opcoesAplicacaoPor"
                        :labelExternal="rotuloAplicacaoPor"
                      />
                    </v-col>
                    <v-col
                      v-if="tab === 'por-valor'"
                      :cols="colsCampoDependente"
                      class="py-2"
                    >
                      <input-by-type
                        v-model="edit.valor"
                        :type="moneyInputType"
                        :labelExternal="rotuloValor"
                        placeholder="0,00"
                        class="new-ux"
                        outlined
                      />
                    </v-col>
                    <template v-if="tab === 'por-quantidade'">
                      <v-col
                        v-if="!edit.resgate_total"
                        :cols="colsCampoDependente"
                        class="py-2"
                      >
                        <input-by-type
                          v-model="edit.qtd"
                          :type="quantityInputType"
                          v-bind="quantityCurrencyProps"
                          labelExternal="Quantidade*"
                          placeholder="0"
                          class="new-ux"
                          outlined
                        />
                      </v-col>
                      <v-col :cols="colsCampoDependente" class="py-2">
                        <input-by-type
                          v-model="edit.pu"
                          :type="moneyInputType"
                          v-bind="puCurrencyProps"
                          :labelExternal="rotuloPrecoUnitario"
                          placeholder="0,00"
                          class="new-ux"
                          outlined
                        />
                      </v-col>
                      <v-col
                        v-if="showPrecoCompra"
                        :cols="colsCampoDependente"
                        class="py-2"
                      >
                        <input-by-type
                          v-model="edit.preco_compra"
                          :type="moneyInputType"
                          :decimalLength="decimalLength"
                          labelExternal="Preço unitário de compra inicial*"
                          placeholder="0,00"
                          class="new-ux"
                          outlined
                        />
                      </v-col>
                    </template>
                  </template>
                  <template v-if="isRV">
                    <v-col cols="4" class="py-2">
                      <input-by-type
                        v-model="edit.impostos"
                        labelExternal="Impostos"
                        :type="moneyInputType"
                        placeholder="0,00"
                        class="new-ux"
                        outlined
                      />
                    </v-col>
                    <v-col cols="4" class="py-2">
                      <input-by-type
                        v-model="edit.taxas"
                        labelExternal="Taxas"
                        :type="moneyInputType"
                        placeholder="0,00"
                        class="new-ux"
                        outlined
                      />
                    </v-col>
                    <v-col v-if="isOffshore" cols="4" class="py-2">
                      <input-by-type
                        v-model="edit.cotacao"
                        labelExternal="Câmbio"
                        type="money"
                        placeholder="0,00"
                        class="new-ux"
                        outlined
                      />
                    </v-col>
                  </template>
                </v-row>

                <div class="text-xs text-color-900 mt-5">
                  Saldo em conta: {{ saldoFormatado }}
                </div>

                <div
                  v-if="mostrarCamposObrigatorios"
                  class="text-xs text-color-900 modal-aporte-resgate__obrigatorios"
                >
                  <span>* Campos obrigatórios</span>
                </div>
              </v-form>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </div>
    </div>
    <template v-slot:actions="{ close }">
      <BaseButton v-if="mostrarCancelar" underlined @click="close">
        Cancelar
      </BaseButton>
      <BaseButton v-else underlined @click="passoAtual = 1">
        Voltar
      </BaseButton>
      <BaseButton
        v-if="passoAtual === 2"
        primary
        :loading="loadingSave"
        @click="salvar(close)"
      >
        Salvar
      </BaseButton>
    </template>
  </BaseModal>
</template>

<style lang="sass">
.modal-aporte-resgate
  .base-modal__content--scrollable,
  .base-modal__content--scrollable > .v-aplication,
  .v-aplication > .v-application,
  .v-application > .v-stepper,
  .v-stepper > .v-stepper__items,
  .v-stepper__items > .v-stepper__content,
  .v-stepper__content > .v-stepper__wrapper,
  .v-stepper__wrapper > div
    display: flex
    flex-direction: column
    flex: 1
    min-height: 0
  .v-stepper__content > .v-stepper__wrapper > form
    display: flex
    flex-direction: column
    flex: 1
    min-height: 0
    > *
      flex: 0 0 auto
  // tabela vazia nao estica: quem ocupa a sobra e a mensagem, centralizada
  .modal-aporte-resgate__tabela--vazia
    flex: 0 0 auto

  .modal-aporte-resgate__vazio
    flex: 1
    min-height: 0

  .modal-aporte-resgate__obrigatorios
    margin-top: auto !important
    padding-top: 20px
  .table-new-ux-v1,
  .v-data-table
    display: flex
    flex-direction: column
    flex: 1
    min-height: 0
  .v-data-table__wrapper
    flex: 1
    min-height: 0
    overflow-y: auto
    &::after
      content: ''
      display: block
      height: 8px
</style>
